module.exports = __webpack_public_path__ + "static/media/1POLICY25.ee50e2a3.jpg";